import React, { Component } from 'react';
import Agreement from '../chart/Agreement.js';
import Past from '../chart/Past.js';
import Prediction from '../chart/Prediction.js';
import './ChartsWrapper.scss';

class ChartsWrapper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minsAndMaxes: this.computeMinsAndMaxes(this.props),
            currentlyDisplayedDataIndex: 0
		};
		this.overlayRef = React.createRef();
		this.tooltipRef = React.createRef();
		this.pastRef = React.createRef();

		this.hoverEventClientX = null;
	};
    overlayData = [{
        label: 'Upper Bound',
        dataKey: 'valueUpperBound',
        color: '#019fdf',
    },{
        label: 'Ghost Prediction',
        dataKey: 'skewedPrediction',
        color: this.props.lineColor,
    },{
        label: 'Lower Bound',
        dataKey: 'valueLowerBound',
        color: '#019fdf',
    }];

    computeMinsAndMaxes(props) {
        let min = Math.min(...props.data.map(a => a.valueLowerBound), ...props.data.map(a => a.skewedPrediction)),
            max = Math.max(...props.data.map(a => a.valueUpperBound), ...props.data.map(a => a.skewedPrediction)),
            absoluteMax = this.props.title === "ACCELERATION" ? 4 : 0.006;
            // absoluteMax = this.props.title === "ACCELERATION" ? 4 : Math.max( Math.abs(max), Math.abs(min));

        return {
            max: absoluteMax,
            min: absoluteMax * -1,
        }
    }
    mouseOut() {
        this.hoverEventClientX = null;
        setTimeout(() => {
            this.tooltipRef.current.style.transform = `translateX(100%)`;
        }, 50)
    }
    getDataIndex(x) {
        const interval = parseInt(process.env.REACT_APP_PAST_CHARTS_INTEVAL, 10);
        const dataInterval = this.overlayRef.current.clientWidth / (this.props.frameRate * interval);
        return Math.round(this.props.currentDataIndex - ((this.overlayRef.current.clientWidth - x) / dataInterval));
    }
    handleAgreementMouseMove(event) {
        this.hoverEventClientX = event ? event.clientX : this.hoverEventClientX;
        this.renderOverlay();

        this.pastRef.current.chart.series[0].points[this.state.currentlyDisplayedDataIndex].onMouseOver();
    }
    renderOverlay(event) {
        // debugger;
		this.hoverEventClientX = event ? event.clientX : this.hoverEventClientX;

		if( this.hoverEventClientX ) {
			let bounds = this.overlayRef.current.getBoundingClientRect(),
				x = this.hoverEventClientX - bounds.left;
			this.tooltipRef.current.style.transform = `translateX(${x}px)`;
			const newDataIndex = this.getDataIndex(x);
			if (newDataIndex > 0 && newDataIndex !== this.currentlyDisplayedDataIndex) {
				this.setState({currentlyDisplayedDataIndex: newDataIndex});
			}
		}
    }
	render() {
        const values = this.overlayData.map(a => {
            return <div className="chartsWrapper__container__infos__valueContainer" key={a.label}>
                        <div className="layout-row layout-align-start-center">
                            <div className="chartsWrapper__container__infos__valueContainer__dot" style={{background: a.color}}></div>
                            <div className="flex">
                                <div className="chartsWrapper__container__infos__valueContainer__label">{a.label}</div>
                                <div className="chartsWrapper__container__infos__valueContainer__value">
                                    {Math.round(this.props.data[this.state.currentlyDisplayedDataIndex][a.dataKey] * 100) / 100}
                                    <span className="chartsWrapper__container__infos__valueContainer__value__unit">{this.props.data[this.state.currentlyDisplayedDataIndex].units}</span>
                                </div>
                            </div>
                        </div>
                    </div>;
        })
		return (
            <div className="chartsWrapper flex layout-column">
                <h3>{this.props.title}</h3>
                <div className="chartsWrapper__container layout-column flex">
                    <div className="chartsWrapper__container__infos layout-column" ref={this.tooltipRef}>
                        <div className="layout-column flex layout-align-center-start">
                            {values}
                        </div>
                        <div className="layout-column layout-align-center-start flex-15">
                            <div className="chartsWrapper__container__infos__valueContainer">
                                <div className="layout-row layout-align-start-center">
                                    <div className="chartsWrapper__container__infos__valueContainer__dot" style={{background: '#2b578b'}}></div>
                                    <div className="flex">
                                        <div className="chartsWrapper__container__infos__valueContainer__label">Agreement Delta</div>
                                        <div className="chartsWrapper__container__infos__valueContainer__value">
                                            {Math.round(this.props.data[this.state.currentlyDisplayedDataIndex].delta * 100) / 100}
                                            <span className="chartsWrapper__container__infos__valueContainer__value__unit">{this.props.data[this.state.currentlyDisplayedDataIndex].units}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="layout-row flex">
                        <div 
                            className="flex-70 chartsWrapper__scroller chartsWrapper__scroller--dashed layout-column layout-align-center-center"
                            onMouseMove={this.renderOverlay.bind(this)}
                            onMouseOut={this.mouseOut.bind(this)}
                            ref={this.overlayRef}
                        >
                            <Past
                                ref={this.pastRef}
                                frameRate={this.props.frameRate}
                                currentDataIndex={this.props.currentDataIndex}
                                data={this.props.data}
                                lineColor={this.props.lineColor}
                                minsAndMaxes={this.state.minsAndMaxes}
                                videoReady={this.props.videoReady}
                                onChartTranslate={() => {
                                   this.handleAgreementMouseMove();
                                }}
                                // logarithmic={this.props.title === 'STEERING'}
                            />
                        </div>
                        <div className="chartsWrapper__separator">
                            <div className="chartsWrapper__separator__text">NOW</div>
                            <div className="chartsWrapper__separator__line"> </div>
                        </div>
                        <div className="flex chartsWrapper__scroller layout-column layout-align-center-center">
                            <Prediction
                                frameRate={this.props.frameRate}
                                currentDataIndex={this.props.currentDataIndex}
                                data={this.props.data}
                                lineColor={this.props.lineColor}
                                minsAndMaxes={this.state.minsAndMaxes}
                                videoReady={this.props.videoReady}
                                // logarithmic={this.props.title === 'STEERING'}
                            />
                        </div>
                    </div>
                    <div className="layout-row flex-15">
                        <div className="flex-70 chartsWrapper__agreement__chart layout-column" onMouseMove={this.handleAgreementMouseMove.bind(this)}
                            onMouseOut={this.mouseOut.bind(this)}>
                            <Agreement
                                frameRate={this.props.frameRate}
                                currentDataIndex={this.props.currentDataIndex}
                                data={this.props.data}
                                lineColor={this.props.lineColor}
                                videoReady={this.props.videoReady}
                                // logarithmic={this.props.title === 'STEERING'}
                            />
                        </div>
                    </div>
                </div>
                <div className="layout-row">
                    <div className="chartsWrapper__agreement__text flex-70">AGREEMENT 𝝙</div>
                </div>
            </div>
		);
	}
}

export default ChartsWrapper;
